import { render, staticRenderFns } from "./optiones.vue?vue&type=template&id=1945ffba&scoped=true"
import script from "./optiones.vue?vue&type=script&lang=js"
export * from "./optiones.vue?vue&type=script&lang=js"
import style0 from "./optiones.vue?vue&type=style&index=0&id=1945ffba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1945ffba",
  null
  
)

export default component.exports